module.exports = __webpack_public_path__ + "img/desktop-icon.61340109.svg";